export default "__VITE_ASSET__DO24XvuW__"